import { z } from 'zod';
export const CompanyRegistryDataComponentSchema = z.object({
    name: z.string(),
    companyNumber: z.string(),
    jurisdictionCode: z.string(),
    incorporationDate: z.string().nullable(),
    dissolutionDate: z.string().nullable(),
    companyType: z.string().nullable(),
    registryUrl: z.string().nullable(),
    openCorporatesUrl: z.string().nullable().optional(),
    isBranch: z.boolean(),
    branchStatus: z.string().nullable(),
    isInactive: z.boolean(),
    currentStatus: z.string().nullable(),
    source: z.object({
        publisher: z.string(),
        url: z.string(),
        retrievedAt: z.string()
    }),
    agentName: z.string().nullable(),
    alternativeNames: z.array(z.object({
        companyName: z.string(),
        type: z.string().nullable(),
        startDate: z.string().nullable(),
        endDate: z.string().nullable(),
        language: z.string().nullable()
    })),
    previousNames: z.array(z.object({
        companyName: z.string(),
        type: z.string().nullable(),
        startDate: z.string().nullable(),
        endDate: z.string().nullable(),
        language: z.string().nullable()
    })),
    numberOfEmployees: z.number().nullable(),
    registeredAddressInFull: z.string().nullable(),
    registeredAddress: z.object({
        country: z.string(),
        locality: z.string().nullable(),
        postalCode: z.string().nullable(),
        region: z.string().nullable(),
        streetAddress: z.string()
    }).nullable(),
    industries: z.array(z.object({
        code: z.string(),
        description: z.string().nullable(),
        codeSchemeId: z.string(),
        codeSchemeName: z.string(),
        uid: z.string()
    })),
    identifiers: z.array(z.object({
        uid: z.string(),
        identifierSystemCode: z.string(),
        identifierSystemName: z.string()
    })),
    officers: z.array(z.object({
        name: z.string(),
        position: z.string().nullable(),
        startDate: z.string().nullable(),
        endDate: z.string().nullable(),
        occupation: z.string().nullable(),
        isInactive: z.boolean(),
        currentStatus: z.string().nullable(),
        address: z.string().nullable()
    }))
});
export const CompanyRegistryCheckResultComponentSchema = z.object({
    success: z.boolean(),
    data: CompanyRegistryDataComponentSchema.optional(),
    error: z.string().optional(),
    source: z.string(),
    jurisdictionCode: z.string(),
    retrievedAt: z.string()
});

//# sourceMappingURL=company-registry.schema.js.map